import type { TTariff } from '../model';

const MINUTE_MS = 60_000;
const MINUTES_IN_HOUR = 60;
const HOURS_IN_DAY = 24;
const FALLBACK_DURATION_DAYS = 365;
const WARNING_THRESHOLD_DAYS = 3;

type TStaticTariffState = {
    type: 'unlimited' | 'suspended' | 'autoRenewal';
    isWarning: boolean;
};

export type TTariffState =
    | TStaticTariffState
    | {
          type: 'remaining';
          isWarning: boolean;
          days: number;
          hours: number;
          minutes: number;
      };

export const getTariffState = (tariffData: TTariff, now = new Date()): TTariffState => {
    if (tariffData.isDefault) {
        return { type: 'unlimited', isWarning: false };
    }

    if (!tariffData.isActive) {
        return { type: 'suspended', isWarning: true };
    }

    if (tariffData.hasRecurrentPayment) {
        return { type: 'autoRenewal', isWarning: false };
    }

    const nowTimestamp = now.getTime();
    const expiresAtTimestamp = tariffData.expiresAt
        ? new Date(tariffData.expiresAt).getTime()
        : nowTimestamp + FALLBACK_DURATION_DAYS * HOURS_IN_DAY * MINUTES_IN_HOUR * MINUTE_MS;
    const totalMinutes = Math.floor(Math.max(expiresAtTimestamp - nowTimestamp, 0) / MINUTE_MS);
    const days = Math.floor(totalMinutes / (HOURS_IN_DAY * MINUTES_IN_HOUR));
    const hours = Math.floor((totalMinutes % (HOURS_IN_DAY * MINUTES_IN_HOUR)) / MINUTES_IN_HOUR);
    const minutes = totalMinutes % MINUTES_IN_HOUR;

    return {
        type: 'remaining',
        isWarning: tariffData.expiresAt !== null && days <= WARNING_THRESHOLD_DAYS,
        days,
        hours,
        minutes,
    };
};
